import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable, effect, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';

/**
 * Quản lý trạng thái Layout (Sidebar, Mobile Mode)
 * Sử dụng Angular Signals và CDK Breakpoints để tối ưu hiệu năng (Zoneless friendly)
 */
@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private breakpointObserver = inject(BreakpointObserver);

  // 1. Nhận diện thiết bị (Mobile/Tablet vs Desktop) dựa trên chuẩn Bootstrap Breakpoints
  // Bootstrap lg = 992px
  isMobile = toSignal(
    this.breakpointObserver
      .observe(['(max-width: 991.98px)'])
      .pipe(map((result) => result.matches)),
    { initialValue: false },
  );

  // 2. Trạng thái Sidebar (Mở rộng hay Thu gọn chỉ hiện icon)
  // Trên Desktop: false = rộng, true = mini
  isSidebarCollapsed = signal(false);

  // 3. Trạng thái Sidebar trên Mobile (Drawer mode)
  isMobileMenuOpen = signal(false);

  constructor() {
    // Tự động đóng/mở sidebar dựa trên kích thước màn hình ban đầu
    effect(() => {
      const mobile = this.isMobile();
      if (mobile) {
        // Trên mobile, mặc định đóng menu và không dùng chế độ mini
        this.isSidebarCollapsed.set(false);
      }
    });
  }

  /**
   * Thay đổi trạng thái Sidebar (Toggle)
   */
  toggleSidebar() {
    if (this.isMobile()) {
      this.isMobileMenuOpen.update((open) => !open);
    } else {
      this.isSidebarCollapsed.update((collapsed) => !collapsed);
    }
  }

  /**
   * Buộc đóng Sidebar (Dùng khi chuyển route trên mobile)
   */
  closeMobileMenu() {
    this.isMobileMenuOpen.set(false);
  }
}
